import { useState } from "react";
import { HelpArticles } from "@/components/help/HelpArticles";
import { HelpLang, useHelpLang } from "@/components/help/HelpLang";
import SupportRequests from "./SupportRequests";

// Client area · Centro assistenza: guides/FAQ and the requests to MUSORA in one place (it/en/es).
export default function HelpCenter({ tid, preset }) {
  const { t, lang } = useHelpLang();
  const [sub, setSub] = useState(preset ? "requests" : "guides");
  return (
    <div className="mx-auto max-w-3xl space-y-5" lang={lang} data-testid="help-center">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div><h2 className="text-lg font-semibold text-slate-900 sm:text-xl">{t("title")}</h2><p className="mt-1 text-sm text-slate-600">{t("subtitle")}</p></div>
        <HelpLang lang={lang} />
      </div>
      <div role="tablist" className="flex gap-1 border-b border-slate-200">
        {["guides", "requests"].map((k) => (
          <button key={k} type="button" role="tab" aria-selected={sub === k} onClick={() => setSub(k)}
            className={`-mb-px min-h-[44px] border-b-2 px-3 text-sm font-medium ${sub === k ? "border-slate-900 text-slate-900" : "border-transparent text-slate-500 hover:text-slate-800"}`}
            data-testid={`help-tab-${k}`}>{t(`tabs.${k}`)}</button>))}
      </div>
      <div hidden={sub !== "guides"}><HelpArticles lang={lang} /></div>
      <div hidden={sub !== "requests"}><SupportRequests tid={tid} preset={preset} showLang={false} /></div>
    </div>);
}
